var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPatientInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.166016C9.22233 0.166016 11.8345 2.77818 11.8345 6.00052C11.8345 9.22227 9.22233 11.8344 6 11.8344C2.77767 11.8344 0.166667 9.22227 0.166667 6.00052C0.166083 2.77818 2.77767 0.166016 6 0.166016ZM5.99767 4.97852C5.85471 4.97871 5.7168 5.03139 5.61013 5.12656C5.50345 5.22173 5.43544 5.35276 5.419 5.49477L5.41492 5.56243L5.41725 8.77193L5.42075 8.84018C5.43719 8.98245 5.5054 9.11369 5.61237 9.20891C5.71934 9.30413 5.8576 9.35668 6.00081 9.35653C6.14402 9.35639 6.28218 9.30357 6.38896 9.20813C6.49574 9.1127 6.56368 8.98131 6.57983 8.83902L6.58333 8.77077L6.581 5.56185L6.57692 5.4936C6.56006 5.35171 6.4917 5.22094 6.38482 5.1261C6.27794 5.03127 6.13997 4.97896 5.99708 4.9791L5.99767 4.97852ZM6.00058 2.7916C5.80696 2.7916 5.62128 2.86851 5.48437 3.00542C5.34746 3.14233 5.27054 3.32802 5.27054 3.52164C5.27054 3.71526 5.34746 3.90095 5.48437 4.03786C5.62128 4.17477 5.80696 4.25168 6.00058 4.25168C6.1942 4.25161 6.37986 4.17462 6.51672 4.03765C6.65357 3.90069 6.73041 3.71497 6.73033 3.52135C6.73026 3.32773 6.65327 3.14207 6.5163 3.00522C6.37934 2.86836 6.19362 2.79152 6 2.7916H6.00058Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPatientInfoIcon);
export default __webpack_public_path__ + "static/media/no-patient-info-icon.59fa345644c2178b4d9cabaf606a5e4e.svg";
export { ForwardRef as ReactComponent };